import { render, staticRenderFns } from "./biddingMonitor.vue?vue&type=template&id=5e56b92b&scoped=true&"
import script from "./biddingMonitor.vue?vue&type=script&lang=js&"
export * from "./biddingMonitor.vue?vue&type=script&lang=js&"
import style0 from "./biddingMonitor.vue?vue&type=style&index=0&id=5e56b92b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56b92b",
  null
  
)

export default component.exports